@if (cartPreviewItem) {
  <div class="cart-preview-item d-flex align-items-center mx-2 my-1">
    <div class="d-flex position-relative">
      <a [routerLink]="['/product', 'detail']"
        [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber, quantityUnit: cartPreviewItem.orderUnit?.quantityUnit}"
        [class.lechaibg]="cartPreviewItem.shoppingCartItem?.isWineShopProduct">
        <img class="w-64px h-max-64px obj-fit-contain obj-position-bottom thumbnail" [src]="cartPreviewItem.thumbnail"
          alt="thumbnail">
      </a>
    </div>
    <span class="mx-2 w-100">
      <a [routerLink]="['/product', 'detail']"
        [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber, quantityUnit: cartPreviewItem.orderUnit?.quantityUnit}">
        {{ cartPreviewItem.description }}
      </a>
      <div class="d-flex">
        <!--
        <app-product-tag-list [productTagList]="cartPreviewItem.productTag"></app-product-tag-list>
        -->
        <span i18n="@@CartPreviewItemProductNumber">Item #</span>
        <span class="ms-auto"></span>
        <a [routerLink]="['/product', 'detail']"
          [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber, quantityUnit: cartPreviewItem.orderUnit?.quantityUnit}">
          {{ cartPreviewItem.productIdentifier!.productNumber }}
        </a>
      </div>
      @if (cartPreviewItem.orderUnit?.quantityUnitCaption != undefined) {
        <div class="d-flex mt-1 mb-2">
          <a [routerLink]="['/product', 'detail']"
            [queryParams]="{ productNumber: cartPreviewItem.productIdentifier?.productNumber, quantityUnit: cartPreviewItem.orderUnit?.quantityUnit}">
            <span class="orderUnit py-1 px-3">{{ cartPreviewItem.orderUnit | quantityUnitToString }}</span>
          </a>
        </div>
      }
      @if (shouldDisplayValidation) {
        <app-cart-validation-result-cart-item [cartItemValidationError]="cartPreviewItem.validationResult"
          [availableQuantity]="cartPreviewItem.availableQuantity" [quantityUnit]="cartPreviewItem.orderUnit">
        </app-cart-validation-result-cart-item>
      }
      @if (cartPreviewItem.promotionDetail != undefined) {
        @for (promotionData of cartPreviewItem.promotionDetail.promotionDataList; track promotionData) {
          <app-promotion-info-pictogram [promotionData]="promotionData"></app-promotion-info-pictogram>
          <app-promotion-info-short [promotionData]="promotionData"></app-promotion-info-short>
        }
      }
      <div class="d-flex mt-1 align-items-center">
        @if (shouldHideQuantityInput != true) {
          <app-quantity-input-bare [quantity]="cartPreviewItem.shoppingCartItem!.quantity"
            [min]="cartPreviewItem.minimumOrderAmount" [max]="cartPreviewItem.maximumOrderAmount"
            [accept]="acceptQuantityChangeTrigger.asObservable()" [reject]="rejectQuantityChangeTrigger.asObservable()"
            (onQuantityChanged)="quantityChanged($event)" (onProductRemoveFromCart)="deleteItem()"
            [disabled]="shouldDisableQuantityInput">
          </app-quantity-input-bare>
        }
        <span class="ms-auto"></span>
        @if (shouldHidePrice != true) {
          <app-price-format [priceFormat]="cartPreviewItem.priceFormat"
            [displayPriceWithoutDiscountsUponDiscounts]="true" [shouldDisplayDeposit]="false"
          [shouldDisplayBasePrice]="false"></app-price-format>
        }
        <ng-container [ngTemplateOutlet]="deleteIcon"></ng-container>
      </div>
    </span>
  </div>
}

<ng-template #deleteIcon>
  <app-product-delete-icon [toolTipHtmlContent]="deleteIconTooltipHtmlContent" (deleteSubmit)="deleteItem()"
    class="d-inline-block ms-2">
  </app-product-delete-icon>
</ng-template>